import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { readAuthToken } from '@noor/api';
import { SignInPage } from '@/pages/sign-in';

/**
 * Post-login landing: the merchants section (schema defaults land on the
 * businesses tab). Shared by the already-signed-in redirect below and the
 * post-submit navigation, so the two can never disagree about where a
 * successful login lands.
 */
export const POST_LOGIN_DESTINATION: {
  to: '/merchants';
  search: Record<string, never>;
} = {
  to: '/merchants',
  search: {},
};

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    // Already signed in → skip the login screen. `redirect()` is TanStack
    // Router's control-flow throw (not an Error) — the intended pattern.
    if (readAuthToken()) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ ...POST_LOGIN_DESTINATION });
    }
  },
  component: LoginRoute,
});

function LoginRoute() {
  const navigate = useNavigate();
  return <SignInPage onSignedIn={() => void navigate(POST_LOGIN_DESTINATION)} />;
}
